import React from 'react';

import DocumentationIcon from '@/assets/icons/documentation.svg?react';
import MeshIcon from '@/assets/icons/mesh.svg?react';
import ChartIcon from '@/assets/icons/chart.svg?react';
import ReservesMonitoringIcon from '@/assets/icons/monitoring-reserves.svg?react';
import AlertingIcon from '@/assets/icons/alerting.svg?react';

import { useNewFeature } from '@/providers/NewFeatureContextProvider/NewFeatureContext.hooks';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { useSidebarManager } from '@/layouts/MainLayout/components/Sidebar/utils/useSidebarManager';
import { IconWithHover } from '@/layouts/MainLayout/components/Sidebar/components/IconWithHover/IconWithHover';
import { StyledTopNavBarWrapper, StyledMenu, StyledMenuItem } from './TopNavigation.styled';
import { ERoutes } from '@/types/routes';

export interface ITopNavigationProps {
  handleMenuToggle: () => void;
}

export const TopNavigation = ({ handleMenuToggle }: ITopNavigationProps) => {
  const {
    open,
    anchorEl,
    handleDocumentationMenuClose,
    handleMenuOptionClick,
    handleEnterDocumentationButton,
    handleLeaveDocumentationButton,
    handleEnterDocumentationMenu,
    handleLeaveDocumentationMenu,
  } = useSidebarManager({
    handleMenuToggle,
  });

  const { isAlertingPermitted } = useNewFeature();
  const { shouldDisplayDocumentation } = usePermissionsManager();

  return (
    <StyledTopNavBarWrapper>
      <IconWithHover
        variant="link"
        href={ERoutes.DASHBOARD}
        Icon={ChartIcon}
        tooltip="Risk Monitoring"
      />

      <IconWithHover
        variant="link"
        href={ERoutes.RISK_SIMULATOR}
        Icon={MeshIcon}
        tooltip="Modeling"
      />
      <IconWithHover
        variant="link"
        href={ERoutes.STABLECOINS}
        Icon={ReservesMonitoringIcon}
        tooltip="Stablecoins"
        tourDataId="stablecoins-navigation-button"
      />

      {isAlertingPermitted && (
        <IconWithHover
          variant="link"
          href={ERoutes.ALERTING}
          Icon={AlertingIcon}
          tooltip="Alerting"
          tourDataId="alerting-navigation-button"
        />
      )}

      {shouldDisplayDocumentation ? (
        <>
          <IconWithHover
            variant="menu"
            onMouseOver={handleEnterDocumentationButton}
            onMouseLeave={handleLeaveDocumentationButton}
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            Icon={DocumentationIcon}
            tooltip="Documentation"
          />
          <StyledMenu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleDocumentationMenuClose}
            slotProps={{
              list: {
                onMouseOver: handleEnterDocumentationMenu,
                onMouseLeave: handleLeaveDocumentationMenu,
                'aria-labelledby': 'basic-button',
              },
            }}
          >
            <StyledMenuItem onClick={() => handleMenuOptionClick('documentation')}>
              Documentation
            </StyledMenuItem>
            <StyledMenuItem onClick={() => handleMenuOptionClick('apiDocs')}>
              API Docs
            </StyledMenuItem>
          </StyledMenu>
        </>
      ) : (
        <IconWithHover
          variant="link"
          href={ERoutes.DOCUMENTATION}
          Icon={DocumentationIcon}
          tooltip="Documentation"
        />
      )}
    </StyledTopNavBarWrapper>
  );
};
